var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcGif(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M19,4c1.1,0,2,0.9,2,2l0,0v12c0,1.1-0.9,2-2,2l0,0H3c-1.1,0-2-0.9-2-2l0,0L1,6c0-1.1,0.9-2,2-2l0,0H19z  M7.1,8.9C6.4,8.9,5.8,9,5.3,9.3c-0.5,0.3-0.9,0.6-1.2,1.1s-0.4,1.1-0.4,1.7c0,0.7,0.1,1.2,0.4,1.7s0.7,0.9,1.2,1.1s1.1,0.4,1.8,0.4 c0.9,0,1.7-0.2,2.4-0.6v-3.1H7v1.1h1v1C7.8,13.9,7.5,14,7.2,14c-0.6,0-1-0.2-1.4-0.5s-0.5-0.8-0.5-1.4c0-0.4,0.1-0.7,0.3-1 c0.2-0.3,0.4-0.5,0.7-0.6s0.6-0.2,1-0.2c0.4,0,0.8,0,1.1,0.1c0.3,0.1,0.6,0.2,0.9,0.5V9.4C9,9.2,8.7,9.1,8.3,9 C8,8.9,7.6,8.9,7.1,8.9z M12.2,9h-1.6v6.3h1.6V9z M18,9h-4.5v6.3h1.6v-2.5h2.1v-1.3h-2.1v-1.2H18V9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGif);
export default __webpack_public_path__ + "static/media/ic_GIF.ba79742e.svg";
export { ForwardRef as ReactComponent };